import React, { FC, useContext } from "react";
import { UserContext } from "context/UserContext";
import { Redirect, Route, RouteProps } from "react-router-dom";

export const AgentRoute: FC<RouteProps> = ({ children, ...props }): JSX.Element => {
  const { isAgent } = useContext(UserContext);

  if (!isAgent) {
    return (
      <Redirect
        to={{
          pathname: "/",
        }}
      />
    );
  }
  return <Route {...props}>{children}</Route>;
};
